"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var _animationHelper = babelHelpers.interopRequireDefault(require("animation-helper"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

class Carousel extends _react.Component {
  constructor(...args) {
    super(...args);
    this.state = {
      cycle: false,
      leftIndex: 0,
      itemsVisible: 1,
      disabled: false
    };
    this.wheelSamples = [0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.sampleCount = 0;
    this.ranWheel = false;

    this.wheelTimeoutHandler = () => {
      if (this.state.disabled) return;

      if (!this.ranWheel) {
        this.runWheel();
      }

      this.ranWheel = false;
      this.wheelTimeout = null;
      this.sampleCount = 0;
      this.wheelSamples = [0, 0, 0, 0, 0, 0, 0, 0, 0];
    };

    this.wheel = event => {
      if (this.state.disabled) return;
      if (this.state.itemsVisible >= this.props.items.length) return;

      if (this.ranWheel) {
        event.preventDefault();
        return;
      }

      console.log(event.deltaMode, event.deltaX, event.deltaY, event.deltaZ);
      this.sampleCount++;
      clearTimeout(this.wheelTimeout);
      this.wheelTimeout = setTimeout(this.wheelTimeoutHandler, 64);
      var offset = 1;
      if (event.deltaMode == 1) offset = 16;
      if (event.deltaMode == 2) offset = window.innerWidth;
      var delta = event.deltaX * offset;
      this.wheelSamples.shift();
      this.wheelSamples.push(delta);
      var dx = 0;

      if (this.wheelSamples.filter(v => Math.abs(this.wheelSamples[4]) - Math.abs(v) > 0).length == 8) {
        dx = this.wheelSamples[4];
      }

      if (dx) {
        this.runWheel();
        this.ranWheel = true;
        event.preventDefault();
      }
    };

    this.touchStart = event => {
      if (this.state.disabled) return;
      this.logTouchEvent(event);

      if (this.inTouch) {
        this.rejectTouch = true;
        event.preventDefault();
        return;
      }

      this.inTouch = true;
      this.rejectTouch = false;
      this.touch = {
        ID: event.touches[0].identifier,
        X: event.touches[0].clientX,
        Y: event.touches[0].clientY
      };
      this.lastTouch = this.touch;
      this.stopped = false; // event.preventDefault();

      return;
    };

    this.touchMove = event => {
      if (this.state.disabled) return;
      if (this.stopped) event.preventDefault();
      this.logTouchEvent(event);

      if (this.inTouch && !this.rejectTouch) {
        this.lastTouch = {
          ID: event.touches[0].identifier,
          X: event.touches[0].clientX,
          Y: event.touches[0].clientY
        };

        if (Math.abs(event.touches[0].clientX - this.touch.X) > 30) {
          console.log("touchMove(): trying to stop movement");
          this.stopped = true;
          event.preventDefault();
        }
      }
    };

    this.touchEnd = event => {
      if (this.state.disabled) return;
      if (this.stopped) event.preventDefault();
      this.logTouchEvent(event);

      if (this.inTouch && !this.rejectTouch && this.touch && this.lastTouch) {
        var delta, size;
        delta = this.lastTouch.X - this.touch.X;
        size = 340;

        if (Math.abs(delta) > 0.1 * size) {
          delta *= -1;
          if (delta < 0) this.cyclePrev();else this.cycleNext();
        }
      }

      this.inTouch = false;
      this.rejectTouch = false;
      this.touch = null;
      this.lastTouch = null;
    };

    this.mediaQueryListener = () => {
      // Enable when the media query specified by props.media matches
      var v = !this.mediaQuery.matches;

      if (v != this.state.disabled) {
        this.setState({
          disabled: v
        });
      }
    };

    this.setContentNode = node => {
      if (this.contentNode) {
        this.contentNode.removeEventListener('wheel', this.wheel, {
          passive: false
        });
        this.contentNode.removeEventListener('touchstart', this.touchStart, {
          passive: false
        });
        this.contentNode.removeEventListener('touchmove', this.touchMove, {
          passive: false
        });
        this.contentNode.removeEventListener('touchend', this.touchEnd, {
          passive: false
        });
      }

      if (this.timer) {
        clearTimeout(this.timer);
      }

      this.contentNode = node;

      if (node) {
        window.addEventListener('resize', this.resized);

        if (!this.props.noControls) {
          node.addEventListener('wheel', this.wheel, {
            passive: false
          });
          node.addEventListener('touchstart', this.touchStart, {
            passive: false
          });
          node.addEventListener('touchmove', this.touchMove, {
            passive: false
          });
          node.addEventListener('touchend', this.touchEnd, {
            passive: false
          });
        }

        if (this.props.period) {
          this.timer = setTimeout(() => this.cycleNext(), this.props.period);
        }

        requestAnimationFrame(this.resized);
      } else {
        window.removeEventListener('resize', this.resized);
      }
    };

    this.resized = () => {
      if (this.state.disabled) return;
      var w = document.body.clientWidth;
      var btn = this.contentNode.parentNode.parentNode.querySelector('.carousel-cycle-prev');
      var bw = btn ? 2 * btn.offsetWidth : 0;
      console.log(`Carousel.resized(): container width = ${w}px, total button width = ${bw}`);
      w -= bw;
      Object.assign(this.contentNode.style, {
        maxWidth: '',
        width: '',
        marginLeft: '',
        marginRight: ''
      });
      var itemWidth = this.contentNode.querySelector('.carousel-item:first-child').offsetWidth;
      w = Math.floor(w / itemWidth) * itemWidth;
      w = Math.max(w, itemWidth);
      Object.assign(this.contentNode.style, {
        maxWidth: `${w}px`,
        width: `${w}px`,
        marginLeft: 'auto',
        marginRight: 'auto'
      });
      this.setState({
        itemsVisible: w / itemWidth
      });
    };

    this.carouselItemNodes = [];
  }

  static setup(parent, props) {
    const carouselItems = [].slice.call(parent.childNodes).filter(node => node.nodeType == 1);

    while (parent.firstChild) parent.removeChild(parent.firstChild);

    props = Object.assign({}, props || {});

    _reactDom.default.render( /*#__PURE__*/_react.default.createElement(Carousel, babelHelpers.extends({
      items: carouselItems
    }, props)), parent);
  }

  runWheel() {
    if (this.state.disabled) return;
    var direction = this.wheelSamples[4] > 0 ? 1 : this.wheelSamples[4] < 0 ? -1 : 0;
    if (direction == 0) return;
    if (direction < 1) this.cyclePrev();else this.cycleNext();
  }

  logTouchEvent(event) {
    console.log(`${event.type}: ${this.mapTouches(event.touches)} | ${this.mapTouches(event.changedTouches)}`);
  }

  mapTouches(touchList) {
    return [].map.call(touchList, touch => `${touch.identifier} @ ${touch.clientX}x${touch.clientY}`).join(', ');
  }

  componentDidMount() {
    if (this.props.media) {
      this.mediaQuery = window.matchMedia(this.props.media);
      this.mediaQuery.addListener(this.mediaQueryListener);
      this.mediaQueryListener();
    }

    this.componentDidUpdate();
  }

  componentWillUnmount() {
    this.setContentNode(null);

    if (this.mediaQuery) {
      this.mediaQuery.removeListener(this.mediaQueryListener);
      delete this.mediaQuery;
    }
  }

  items() {
    return this.props.items.slice(this.state.leftIndex).concat(this.props.items.slice(0, this.state.leftIndex));
  }

  render() {
    if (this.state.disabled) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: _classList.default.join('disabled-carousel-container')
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: _classList.default.join('carousel-content')
      }, this.props.items.map((carouselItem, index) => /*#__PURE__*/_react.default.createElement("div", {
        className: "carousel-item",
        key: index,
        ref: node => this.setupDisabledCarouselItem(node, carouselItem)
      }))));
    }

    return /*#__PURE__*/_react.default.createElement("div", {
      className: _classList.default.join('carousel-container', this.props.noControls ? 'carousel-without-controls' : null, this.props.indicators ? 'carousel-with-indicators' : null)
    }, !this.props.noControls ? /*#__PURE__*/_react.default.createElement("div", {
      className: "carousel-cycle-prev"
    }, this.state.itemsVisible < this.props.items.length ? /*#__PURE__*/_react.default.createElement("button", {
      onClick: () => this.cyclePrev()
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "glyphicon arrow-circle-icon glyphicon-circle-arrow-left",
      "aria-hidden": true
    })) : null) : null, this.props.indicators ? /*#__PURE__*/_react.default.createElement("div", {
      className: "carousel-indicator-box"
    }, this.props.items.map((carouselItem, index) => /*#__PURE__*/_react.default.createElement("div", {
      key: index,
      style: {
        transition: `${this.props.speed || '300'}ms ease`
      },
      className: _classList.default.join('carousel-indicator-item', this.items().slice(0, this.state.itemsVisible).indexOf(carouselItem) != -1 ? 'active' : '')
    }))) : null, /*#__PURE__*/_react.default.createElement("div", {
      className: _classList.default.join('carousel-content', this.state.itemsVisible >= this.props.items.length ? 'carousel-content-centered' : ''),
      ref: this.setContentNode
    }, this.state.itemsVisible < this.props.items.length ? /*#__PURE__*/_react.default.createElement("div", {
      className: "carousel-item previous-space",
      key: "previous",
      ref: node => this.setupCarouselItem(node, null, "previous")
    }) : null, this.items().map((carouselItem, index) => /*#__PURE__*/_react.default.createElement("div", {
      className: "carousel-item",
      key: index,
      "data-active": index < this.state.itemsVisible ? 'true' : 'false',
      ref: node => this.setupCarouselItem(node, carouselItem)
    })),
    /* We don't actually need a 'next-space' */
    null), !this.props.noControls ? /*#__PURE__*/_react.default.createElement("div", {
      className: "carousel-cycle-next"
    }, this.state.itemsVisible < this.props.items.length ? /*#__PURE__*/_react.default.createElement("button", {
      onClick: () => this.cycleNext()
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "glyphicon arrow-circle-icon glyphicon-circle-arrow-right",
      "aria-hidden": true
    })) : null) : null);
  }

  setupCarouselItem(node, carouselNode, asPreviousItem) {
    if (!carouselNode && asPreviousItem == 'previous') {
      var t = this.items();
      carouselNode = t[t.length - 1].cloneNode(true);
    }

    if (node) {
      node.style.transform = '';

      while (node.firstChild) node.removeChild(node.firstChild);

      node.appendChild(carouselNode);
    }

    if (asPreviousItem == 'previous') return;
    let x = this.carouselItemNodes.findIndex(v => v.node == carouselNode);

    if (x > -1) {
      this.carouselItemNodes[x].element = node;
    } else {
      this.carouselItemNodes.push({
        node: carouselNode,
        element: node,
        isActive: ''
      });
    }
  }

  componentDidUpdate() {
    this.carouselItemNodes = this.carouselItemNodes.filter(v => v.element);
    this.carouselItemNodes.forEach(t => {
      if (t.element.dataset.active != t.isActive) {
        var _this$props$didChange, _this$props;

        t.isActive = t.element.dataset.active;
        (_this$props$didChange = (_this$props = this.props).didChange) === null || _this$props$didChange === void 0 ? void 0 : _this$props$didChange.call(_this$props, t.node, t.element, this.props.items.indexOf(t.node), t.element.dataset.active == 'true');
      }
    });
  }

  setupDisabledCarouselItem(node, carouselNode) {
    if (node) {
      node.style.transform = '';

      while (node.firstChild) node.removeChild(node.firstChild);

      node.appendChild(carouselNode);
    }
  }

  cyclePrev() {
    if (this.animation) return;
    if (this.state.disabled) return;

    if (this.state.itemsVisible >= this.props.items.length) {
      if (this.props.period) this.timer = setTimeout(() => this.cycleNext(), this.props.period);
      return;
    }

    var positionCallback = position => {
      var pp = -100 + 100 * position;
      console.log(pp);
      this.contentNode.querySelectorAll(':scope > .carousel-item').forEach(node => node.style.transform = `translateX(${pp}%)`);
    };

    var finishedCallback = finished => {
      if (!finished) positionCallback(1);
      delete this.animation;
      this.setState(state => {
        var lp = state.leftIndex - 1;
        if (lp == -1) lp = this.props.items.length - 1;
        return {
          leftIndex: lp
        };
      });
      clearTimeout(this.timer);
      if (this.props.period) this.timer = setTimeout(() => this.cycleNext(), this.props.period);
    };

    this.animation = new _animationHelper.default(this.props.speed || 300, 'ease', positionCallback, finishedCallback);
    requestAnimationFrame(() => {
      this.animation.start();
    });
  }

  cycleNext() {
    if (this.animation) return;
    if (this.state.disabled) return;

    if (this.state.itemsVisible >= this.props.items.length) {
      if (this.props.period) this.timer = setTimeout(() => this.cycleNext(), this.props.period);
      return;
    }

    var positionCallback = position => {
      var pp = -100 - 100 * position;
      this.contentNode.querySelectorAll(':scope > .carousel-item').forEach(node => node.style.transform = `translateX(${pp}%)`);
    };

    var finishedCallback = finished => {
      if (!finished) positionCallback(1);
      delete this.animation;
      this.setState(state => {
        var lp = state.leftIndex + 1;
        if (lp == this.props.items.length) lp = 0;
        return {
          leftIndex: lp
        };
      });
      clearTimeout(this.timer);
      if (this.props.period) this.timer = setTimeout(() => this.cycleNext(), this.props.period);
    };

    this.animation = new _animationHelper.default(this.props.speed || 300, 'ease', positionCallback, finishedCallback);
    requestAnimationFrame(() => {
      this.animation.start();
    });
  }

}

exports.default = Carousel;